import img1 from './images/caseStudy1.png';
import img2 from './images/caseStudy2.png';
import img3 from './images/caseStudy3.png';
import img4 from './images/caseStudy4.png';
import img5 from './images/caseStudy5.png';

const thumbnails = [img1, img2, img3, img4, img5];

import { caseStudyData } from './HelpCaseStudy.data';
import { ArrayItem } from '@client/new/helpers/types';
import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from './CaseStudies.css';

type CaseStudyCardProps = ArrayItem<typeof caseStudyData> & {
  thumbnailSrc: string;
};
export const CaseStudyCard = (e: CaseStudyCardProps) => (
  <div className={styles.caseWrapper}>
    <div className={styles.image}>
      <img
        src={e.thumbnailSrc}
        width={120}
        height={96}
        className={styles.image}
      />
    </div>
    <Col className="text-center md:text-left">
      <Typography variant="title" size="small" className={styles.title}>
        {e.title}
      </Typography>
      <Typography variant="body" size="medium" className={styles.summary}>
        {e.summary}
      </Typography>
      <a href={e.url} target="_blank" rel="noreferrer">
        Read more
      </a>
    </Col>
  </div>
);

export const CaseStudies = () => {
  return (
    <Col className={styles.caseStudies} gap="xl">
      <Typography variant="headline" size="medium">
        Key Case Studies
      </Typography>
      <Col className={styles.cases} gap="xl">
        {caseStudyData.map((e, i) =>
          i < thumbnails.length ? (
            <CaseStudyCard {...e} thumbnailSrc={thumbnails[i]} key={i} />
          ) : null,
        )}
      </Col>
    </Col>
  );
};
